import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as orderActions from "../../../../../actions/intergammaOrderActions";

class WarningMissingDataModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleButtonClick = () => {
        if (this.props.params.barcode !== null) {
            if (this.props.params.barcode.startsWith("%O")) {
                this.props.dispatchSendOrderByBarcodeAction(
                    this.props.tabId,
                    this.props.params.formula,
                    this.props.params.barcode,
                    this.props.params.receiver
                );
            } else {
                this.props.dispatchSendOrderByHistoryBarcodeAction(
                    this.props.tabId,
                    this.props.params.formula,
                    this.props.params.barcode,
                    this.props.params.receiver
                );
            }
        }

        this.props.dispatchCloseModalAction();
    };

    getTitle = () => {
        if (!this.props.params.product.id) {
            return (
                <div className="col-xs-12 ">
                    <Translate value="warningMissingDataModal.notFoundProduct" />
                    <div className="modal-div-space">
                        <div>
                            {translate("general.product")}:{" "}
                            <span className="modal-warning">{this.props.params.product.displayName}</span>
                        </div>
                    </div>
                </div>
            );
        } else if (!this.props.params.base.id) {
            return (
                <div className="col-xs-12 ">
                    <Translate value="warningMissingDataModal.notFoundBase" />
                    <div className="modal-div-space">
                        <div>
                            {translate("general.base")}:{" "}
                            <span className="modal-warning">{this.props.params.base.displayName}</span>
                        </div>
                    </div>
                </div>
            );
        } else if (!this.props.params.fandeck.id || !this.props.params.color.id) {
            return (
                <div className="col-xs-12 ">
                    <Translate value="warningMissingDataModal.continue" />
                    {!this.props.params.fandeck.id ? (
                        <div>
                            {translate("general.fandeck")}:{" "}
                            <span className="modal-warning">{this.props.params.fandeck.displayName}</span>
                        </div>
                    ) : null}
                    {!this.props.params.color.id ? (
                        <div>
                            {translate("general.color")}:{" "}
                            <span className="modal-warning">{this.props.params.color.displayName}</span>
                        </div>
                    ) : null}
                </div>
            );
        }

        return <Translate value="warningMissingDataModal.continue" />;
    };

    render() {
        return (
            <div id="modal" className="default-modal ig-restart-modal ig-small-modal">
                <div className="modal-content">
                    {this.getTitle()}
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleCloseModalClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.cancel" />
                            </button>
                        </div>
                        <div className="col-xs-6 text-left ">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.confirm" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_WARNING_MISSING_DATA_MODAL));
        },
        dispatchSendOrderByBarcodeAction: (tabId, formula, barcode, receiver) => {
            dispatch(orderActions.sendOrderByBarcode(tabId, formula, barcode, receiver));
        },
        dispatchSendOrderByHistoryBarcodeAction: (tabId, formula, barcode, receiver) => {
            dispatch(orderActions.sendOrderByHistoryBarcode(tabId, formula, barcode, receiver));
        }
    };
};

export default WarningMissingDataModal = connect(mapStoreToProps, mapDispatchToProps)(WarningMissingDataModal);
